module.exports = __webpack_public_path__ + "assets/img/34_708.a8ce436f.jpg";